import { render, staticRenderFns } from "./FeeHistory.vue?vue&type=template&id=1b3f6c75&scoped=true&"
import script from "./FeeHistory.vue?vue&type=script&lang=js&"
export * from "./FeeHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3f6c75",
  null
  
)

export default component.exports